/* Olilu welcome offer: the tissue reveal (snippets/welcome-tissue.liquid, styles in section-welcome.css).
   Opens once: after 20s of visible time, on the second page view of a visit, or on exit intent on desktop
   (the mouse leaving through the top of the window). collection.landing waits 30s before any of these.
   Never for customers with orders, anyone with the olilu_subscribed cookie, or for 30 days after it was closed.
   Add #welcome to a page address to open it on demand (owner preview).
   Flow: brush the tissue (or "Reveal without brushing") -> choose a gift -> email -> Shopify customer form
   (tags newsletter,welcome-10 or newsletter,welcome-5) -> the code is applied with /discount/CODE. */
(function () {
  'use strict';
  var O = window.Olilu;
  if (!O) return;
  var cfg = O.cfg || window.oliluConfig || {};

  var DAY = 864e5;
  var KEY_CLOSED = 'olilu_welcome_closed';
  var KEY_PENDING = 'olilu_welcome_pending';
  var KEY_VIEWS = 'olilu_pv';
  var COOKIE = 'olilu_subscribed';
  var BRUSH = 24;          // brush width in px
  var CLEAR_AT = 0.45;     // share of the tissue that must be brushed away
  var CELL = 8;            // grid used to measure how much has been brushed

  /* ---------- Storage (every access guarded: private windows and blocked storage throw) ---------- */
  function storage(type) { try { return window[type] || null; } catch (e) { return null; } }
  var local = storage('localStorage'), session = storage('sessionStorage');
  function get(s, k) { try { return s ? s.getItem(k) : null; } catch (e) { return null; } }
  function put(s, k, v) { try { if (s) s.setItem(k, v); } catch (e) { /* ignore */ } }
  function drop(s, k) { try { if (s) s.removeItem(k); } catch (e) { /* ignore */ } }

  function hasCookie(name) {
    return document.cookie.split(/;\s*/).some(function (c) { return c.indexOf(name + '=') === 0; });
  }
  function setCookie(name, value, days) {
    document.cookie = name + '=' + encodeURIComponent(value) + '; max-age=' + days * 86400 + '; path=/; SameSite=Lax' + (location.protocol === 'https:' ? '; Secure' : '');
  }
  function closedRecently() {
    var t = Number(get(local, KEY_CLOSED));
    return !!t && Date.now() - t < 30 * DAY;
  }
  function readPending() {
    try {
      var p = JSON.parse(get(session, KEY_PENDING) || 'null');
      if (p && Date.now() - p.t < 30 * 60 * 1000) return p;
    } catch (e) { /* ignore */ }
    drop(session, KEY_PENDING);
    return null;
  }
  function token(name, fallback) {
    var v = getComputedStyle(document.documentElement).getPropertyValue(name).trim();
    return v || fallback;
  }
  function reducedMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  O.ready('[data-welcome]', function (el) {
    var tpl = el.querySelector('[data-welcome-tpl]');
    if (!tpl || !('content' in tpl)) return;

    var built = false, state = 'tissue', revealed = false, cssReady = null;
    var minDelay = Number(el.getAttribute('data-min-delay')) || 0;
    var form, tags, email, submit, err, canvas, parcel;

    /* ---------- Opening ---------- */
    function loadCss() {
      if (cssReady) return cssReady;
      var href = el.getAttribute('data-css');
      cssReady = new Promise(function (resolve) {
        if (!href) { resolve(); return; }
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = href;
        link.onload = link.onerror = function () { resolve(); };
        setTimeout(resolve, 2500);
        document.head.appendChild(link);
      });
      return cssReady;
    }

    function show(after) {
      loadCss().then(function () {
        build();
        O.drawer.open(el);
        // Wait for layout so the canvas can measure itself
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            initTissue();
            if (after) after();
          });
        });
      });
    }

    function build() {
      if (built) return;
      built = true;
      el.appendChild(tpl.content.cloneNode(true));
      form = el.querySelector('form');
      tags = el.querySelector('[data-welcome-tags]');
      email = el.querySelector('input[type="email"]');
      submit = el.querySelector('[data-welcome-submit]');
      err = el.querySelector('[data-welcome-error]');
      canvas = el.querySelector('[data-tissue-canvas]');
      parcel = el.querySelector('[data-parcel]');

      var revealBtn = el.querySelector('[data-welcome-reveal]');
      if (revealBtn) revealBtn.addEventListener('click', function () { reveal(); });

      O.$$('input[name="welcome_gift"]', el).forEach(function (r) {
        r.addEventListener('change', function () { if (r.checked && tags) tags.value = r.getAttribute('data-tags'); });
      });
      if (email) {
        email.addEventListener('input', function () {
          if (err) err.hidden = true;
          email.removeAttribute('aria-invalid');
        });
      }
      if (form) form.addEventListener('submit', onSubmit);

      el.addEventListener('drawer:close', function () {
        // Closing without signing up (X, "No thanks", Esc or the scrim) hides it for 30 days
        if (state !== 'done') put(local, KEY_CLOSED, String(Date.now()));
      });
    }

    function showStep(name) {
      state = name;
      O.$$('[data-step]', el).forEach(function (s) { s.hidden = s.getAttribute('data-step') !== name; });
      var no = el.querySelector('[data-welcome-no]');
      if (no) no.hidden = name === 'done';
      O.$$('.welcome__panel, .welcome__body', el).forEach(function (n) { n.scrollTop = 0; });
      var f = el.querySelector('[data-step="' + name + '"] [data-step-focus]');
      if (f) f.focus({ preventScroll: true });
    }

    /* ---------- The tissue ---------- */
    var ctx = null, grid = null, cols = 0, rows = 0, total = 1, cleared = 0, touched = false;

    function initTissue() {
      if (!canvas || canvas.__ready) return;
      var box = canvas.getBoundingClientRect();
      ctx = canvas.getContext ? canvas.getContext('2d') : null;
      if (!ctx || !box.width || !box.height) {
        // No canvas support: show the gift straight away
        if (parcel) parcel.classList.add('is-ready');
        canvas.classList.add('is-gone');
        return;
      }
      canvas.__ready = true;
      var w = box.width, h = box.height;
      var dpr = Math.min(window.devicePixelRatio || 1, 2.5);
      canvas.width = Math.round(w * dpr);
      canvas.height = Math.round(h * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      cols = Math.ceil(w / CELL);
      rows = Math.ceil(h / CELL);
      total = cols * rows;
      grid = new Uint8Array(total);

      paint(w, h, null);
      if (parcel) parcel.classList.add('is-ready');

      var img = new Image();
      img.decoding = 'async';
      img.onload = function () { if (!touched && !revealed) paint(w, h, img); };
      img.src = el.getAttribute('data-tissue');

      var down = false, last = null;
      function at(e) {
        var r = canvas.getBoundingClientRect();
        return { x: e.clientX - r.left, y: e.clientY - r.top };
      }
      canvas.addEventListener('pointerdown', function (e) {
        if (revealed) return;
        down = true;
        last = at(e);
        brush(last, last);
        try { canvas.setPointerCapture(e.pointerId); } catch (x) { /* ignore */ }
      });
      canvas.addEventListener('pointermove', function (e) {
        if (revealed) return;
        // A mouse brushes just by moving over the tissue; touch and pen brush while pressed
        if (!down && e.pointerType !== 'mouse') return;
        var p = at(e);
        if (last) brush(last, p);
        last = p;
      });
      ['pointerup', 'pointercancel'].forEach(function (t) {
        canvas.addEventListener(t, function (e) { down = false; if (e.pointerType !== 'mouse') last = null; });
      });
      canvas.addEventListener('pointerleave', function () { down = false; last = null; });
    }

    function paint(w, h, img) {
      ctx.globalCompositeOperation = 'source-over';
      ctx.clearRect(0, 0, w, h);
      ctx.fillStyle = token('--c-oat', '#ECE6DB');
      ctx.fillRect(0, 0, w, h);
      if (img && img.naturalWidth) {
        var s = Math.max(w / img.naturalWidth, h / img.naturalHeight);
        var dw = img.naturalWidth * s, dh = img.naturalHeight * s;
        ctx.drawImage(img, (w - dw) / 2, (h - dh) / 2, dw, dh);
      }
      seal(w / 2, h / 2);
    }

    // A Titicaca wax seal with the spiral O from the logo
    function seal(cx, cy) {
      var wax = token('--c-titicaca', '#0E5878');
      var i, a, r;
      ctx.save();
      ctx.beginPath();
      for (i = 0; i <= 36; i++) {
        a = i / 36 * Math.PI * 2;
        r = 25 + Math.sin(a * 5) * 0.9 + Math.cos(a * 3 + 0.6) * 0.8;
        if (i) ctx.lineTo(cx + Math.cos(a) * r, cy + Math.sin(a) * r);
        else ctx.moveTo(cx + Math.cos(a) * r, cy + Math.sin(a) * r);
      }
      ctx.closePath();
      ctx.shadowColor = 'rgba(30, 37, 40, .28)';
      ctx.shadowBlur = 5;
      ctx.shadowOffsetY = 1.5;
      ctx.fillStyle = wax;
      ctx.fill();
      ctx.shadowColor = 'transparent';

      // pressed rim
      ctx.beginPath();
      ctx.arc(cx, cy, 19.5, 0, Math.PI * 2);
      ctx.lineWidth = 1;
      ctx.strokeStyle = 'rgba(255, 255, 255, .26)';
      ctx.stroke();
      ctx.beginPath();
      ctx.arc(cx, cy + 0.8, 19.5, 0.15 * Math.PI, 0.85 * Math.PI);
      ctx.strokeStyle = 'rgba(0, 0, 0, .18)';
      ctx.stroke();

      // spiral
      ctx.beginPath();
      var turns = 2.4, max = turns * Math.PI * 2;
      for (a = 0; a <= max; a += 0.12) {
        r = 1.6 + a / max * 12;
        var x = cx + Math.cos(a - Math.PI / 2) * r, y = cy + Math.sin(a - Math.PI / 2) * r;
        if (a) ctx.lineTo(x, y); else ctx.moveTo(x, y);
      }
      ctx.lineWidth = 1.7;
      ctx.lineCap = 'round';
      ctx.lineJoin = 'round';
      ctx.strokeStyle = 'rgba(255, 255, 255, .82)';
      ctx.stroke();
      ctx.restore();
    }

    function brush(a, b) {
      touched = true;
      ctx.save();
      ctx.globalCompositeOperation = 'destination-out';
      ctx.lineCap = 'round';
      ctx.lineJoin = 'round';
      ctx.lineWidth = BRUSH;
      ctx.beginPath();
      ctx.moveTo(a.x, a.y);
      ctx.lineTo(b.x + 0.01, b.y);
      ctx.stroke();
      ctx.restore();
      mark(a, b);
      if (cleared / total >= CLEAR_AT) reveal();
    }

    // Marks the grid cells under the brush, so no pixel reads are needed (works with images from the CDN)
    function mark(a, b) {
      var R = BRUSH / 2, dx = b.x - a.x, dy = b.y - a.y;
      var steps = Math.max(1, Math.ceil(Math.sqrt(dx * dx + dy * dy) / 4));
      for (var s = 0; s <= steps; s++) {
        var x = a.x + dx * s / steps, y = a.y + dy * s / steps;
        var c0 = Math.max(0, Math.floor((x - R) / CELL)), c1 = Math.min(cols - 1, Math.floor((x + R) / CELL));
        var r0 = Math.max(0, Math.floor((y - R) / CELL)), r1 = Math.min(rows - 1, Math.floor((y + R) / CELL));
        for (var r = r0; r <= r1; r++) {
          for (var c = c0; c <= c1; c++) {
            var i = r * cols + c;
            if (grid[i]) continue;
            var ox = c * CELL + CELL / 2 - x, oy = r * CELL + CELL / 2 - y;
            if (ox * ox + oy * oy <= R * R) { grid[i] = 1; cleared++; }
          }
        }
      }
    }

    function reveal() {
      if (revealed) return;
      revealed = true;
      if (parcel) parcel.classList.add('is-ready');
      if (canvas) canvas.classList.add('is-gone'); // fades over 400ms in the stylesheet
      setTimeout(function () { showStep('choose'); }, reducedMotion() ? 250 : 1100);
    }

    /* ---------- Sign-up ---------- */
    function fail(msg) {
      if (submit) { submit.classList.remove('is-loading'); submit.removeAttribute('aria-busy'); }
      if (!err) return;
      err.textContent = msg;
      err.hidden = false;
      if (email) email.setAttribute('aria-invalid', 'true');
    }

    function onSubmit(e) {
      e.preventDefault();
      if (submit && submit.classList.contains('is-loading')) return;
      var value = (email.value || '').trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(value)) {
        fail('Please enter your email address, for example name@example.com.');
        email.focus();
        return;
      }
      email.value = value;
      var choice = form.querySelector('input[name="welcome_gift"]:checked');
      var code = choice ? choice.getAttribute('data-code') : '';
      if (choice && tags) tags.value = choice.getAttribute('data-tags');
      if (submit) { submit.classList.add('is-loading'); submit.setAttribute('aria-busy', 'true'); }
      put(session, KEY_PENDING, JSON.stringify({ code: code, t: Date.now() }));

      fetch(form.action, { method: 'POST', body: new FormData(form), credentials: 'same-origin' })
        .then(function (res) {
          var url = res.url || '';
          if (/\/challenge/.test(url)) throw new Error('challenge');
          if (/[?&]customer_posted=true/.test(url) || res.redirected || res.ok) {
            drop(session, KEY_PENDING);
            success(code);
            return;
          }
          throw new Error(String(res.status));
        })
        .catch(function () {
          // Post the form normally; Shopify's own page handles any spam check, and we pick up the
          // pending gift when it sends the shopper back with ?customer_posted=true
          form.submit();
        });
    }

    function success(code) {
      setCookie(COOKIE, '1', 365);
      drop(local, KEY_CLOSED);
      if (code) {
        var root = (cfg.routes && cfg.routes.root) || '/';
        if (root.slice(-1) !== '/') root += '/';
        fetch(root + 'discount/' + encodeURIComponent(code), { credentials: 'same-origin' }).catch(function () { /* the code is in the email too */ });
        var c = el.querySelector('[data-welcome-code]');
        if (c) c.textContent = code;
      }
      if (submit) { submit.classList.remove('is-loading'); submit.removeAttribute('aria-busy'); }
      showStep('done');
      document.dispatchEvent(new CustomEvent('olilu:welcome-subscribed', { detail: { code: code } }));
    }

    /* ---------- When to open ---------- */
    window.addEventListener('hashchange', function () { if (location.hash === '#welcome') show(); });
    document.addEventListener('olilu:welcome-open', function () { show(); });

    if (/\/challenge/.test(location.pathname)) return;

    var pending = readPending();
    if (pending && /[?&]customer_posted=true/.test(location.search)) {
      drop(session, KEY_PENDING);
      show(function () { success(pending.code); });
      return;
    }
    if (location.hash === '#welcome') { show(); return; }
    if (el.hasAttribute('data-design-mode')) return;
    if (Number(cfg.customer) > 0 || hasCookie(COOKIE) || closedRecently()) return;

    var secs = 0, want = false, done = false;
    var views = Number(get(session, KEY_VIEWS)) || 1;
    var exitIntent = !!(window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 990px)').matches);

    function busy() {
      var a = document.activeElement;
      if (a && a !== document.body && /^(INPUT|TEXTAREA|SELECT)$/.test(a.tagName)) return true;
      var open = O.$$('.drawer.is-open').filter(function (d) { return d !== el; });
      return open.length > 0;
    }
    function trigger() {
      if (done) return;
      want = true;
      if (busy()) return; // another drawer is open or someone is typing: try again on the next tick
      done = true;
      clearInterval(timer);
      document.removeEventListener('mouseout', onExit);
      show();
    }
    function tick() {
      if (document.visibilityState === 'visible') secs++;
      if (secs < minDelay) return;
      if (want || secs >= 20 || (views >= 2 && secs >= 4)) trigger();
    }
    function onExit(e) {
      if (e.relatedTarget || e.clientY > 0) return;
      if (secs < Math.max(3, minDelay)) return;
      trigger();
    }
    var timer = setInterval(tick, 1000);
    if (exitIntent) document.addEventListener('mouseout', onExit);
  });
})();
